import React from 'react';
import { useTranslation } from 'react-i18next';

const ValueIcon = ({ type }: { type: string }): React.ReactElement => {
  const icons: Record<string, React.ReactElement> = {
    efficiency: (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <linearGradient id="ef1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient>
          <filter id="efg"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
        </defs>
        <circle cx="40" cy="40" r="28" fill="none" stroke="url(#ef1)" strokeWidth="2" opacity="0.85" filter="url(#efg)"/>
        <circle cx="40" cy="40" r="28" fill="#4A9EE8" opacity="0.07"/>
        <polygon points="40,18 47,34 64,34 50,44 55,60 40,50 25,60 30,44 16,34 33,34" fill="#7DBFF5" opacity="0.9" filter="url(#efg)"/>
        <circle cx="40" cy="12" r="3.5" fill="#7DBFF5" opacity="0.9"/>
        <circle cx="68" cy="40" r="2.5" fill="#4A9EE8" opacity="0.7"/>
        <circle cx="12" cy="40" r="2.5" fill="#4A9EE8" opacity="0.7"/>
        <circle cx="40" cy="68" r="3" fill="#7DBFF5" opacity="0.8"/>
      </svg>
    ),
    lifecycle: (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <linearGradient id="lc1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient>
          <filter id="lcg"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
        </defs>
        <circle cx="40" cy="40" r="26" fill="none" stroke="url(#lc1)" strokeWidth="2" opacity="0.85" filter="url(#lcg)"/>
        <circle cx="40" cy="40" r="26" fill="#4A9EE8" opacity="0.06"/>
        <path d="M40 18 L40 40 L54 54" fill="none" stroke="#7DBFF5" strokeWidth="2.5" strokeLinecap="round" filter="url(#lcg)" opacity="0.9"/>
        <circle cx="40" cy="40" r="4" fill="#7DBFF5" opacity="0.95" filter="url(#lcg)"/>
        <line x1="40" y1="10" x2="40" y2="16" stroke="#4A9EE8" strokeWidth="2" opacity="0.7"/>
        <line x1="40" y1="64" x2="40" y2="70" stroke="#4A9EE8" strokeWidth="2" opacity="0.7"/>
        <line x1="10" y1="40" x2="16" y2="40" stroke="#4A9EE8" strokeWidth="2" opacity="0.7"/>
        <line x1="64" y1="40" x2="70" y2="40" stroke="#4A9EE8" strokeWidth="2" opacity="0.7"/>
        <circle cx="40" cy="10" r="3" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="70" cy="40" r="3" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="40" cy="70" r="3" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="10" cy="40" r="3" fill="#4A9EE8" opacity="0.8"/>
      </svg>
    ),
    reliability: (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <linearGradient id="rl1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient>
          <filter id="rlg"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
        </defs>
        <polyline points="10,52 22,32 34,44 46,20 58,36 70,28" fill="none" stroke="url(#rl1)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.9" filter="url(#rlg)"/>
        <line x1="10" y1="62" x2="70" y2="62" stroke="#4A9EE8" strokeWidth="1" opacity="0.3"/>
        <circle cx="10" cy="52" r="3.5" fill="#7DBFF5" opacity="0.9"/>
        <circle cx="22" cy="32" r="3" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="34" cy="44" r="3" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="46" cy="20" r="4" fill="#7DBFF5" opacity="0.95" filter="url(#rlg)"/>
        <circle cx="58" cy="36" r="3" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="70" cy="28" r="3.5" fill="#7DBFF5" opacity="0.9"/>
      </svg>
    ),
    safety: (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <linearGradient id="sf1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient>
          <filter id="sfg"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
        </defs>
        <path d="M40 8 L64 19 L64 43 Q64 60 40 72 Q16 60 16 43 L16 19 Z" fill="#4A9EE8" opacity="0.08"/>
        <path d="M40 8 L64 19 L64 43 Q64 60 40 72 Q16 60 16 43 L16 19 Z" fill="none" stroke="url(#sf1)" strokeWidth="2" opacity="0.9" filter="url(#sfg)"/>
        <polyline points="29,41 37,49 53,31" fill="none" stroke="#7DBFF5" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" filter="url(#sfg)" opacity="0.95"/>
        <circle cx="40" cy="8" r="3.5" fill="#7DBFF5" opacity="0.9"/>
        <circle cx="64" cy="19" r="2.5" fill="#4A9EE8" opacity="0.7"/>
        <circle cx="16" cy="19" r="2.5" fill="#4A9EE8" opacity="0.7"/>
      </svg>
    ),
    customization: (
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <linearGradient id="cu1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#7DBFF5"/><stop offset="100%" stopColor="#2478C8"/></linearGradient>
          <filter id="cug"><feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
        </defs>
        <circle cx="40" cy="40" r="16" fill="none" stroke="url(#cu1)" strokeWidth="2" opacity="0.9" filter="url(#cug)"/>
        <circle cx="40" cy="40" r="16" fill="#4A9EE8" opacity="0.1"/>
        <circle cx="40" cy="40" r="6" fill="#7DBFF5" opacity="0.9" filter="url(#cug)"/>
        <line x1="40" y1="10" x2="40" y2="24" stroke="#4A9EE8" strokeWidth="2" opacity="0.8"/>
        <line x1="40" y1="56" x2="40" y2="70" stroke="#4A9EE8" strokeWidth="2" opacity="0.8"/>
        <line x1="10" y1="40" x2="24" y2="40" stroke="#4A9EE8" strokeWidth="2" opacity="0.8"/>
        <line x1="56" y1="40" x2="70" y2="40" stroke="#4A9EE8" strokeWidth="2" opacity="0.8"/>
        <line x1="18" y1="18" x2="28" y2="28" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <line x1="52" y1="52" x2="62" y2="62" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <line x1="62" y1="18" x2="52" y2="28" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <line x1="28" y1="52" x2="18" y2="62" stroke="#4A9EE8" strokeWidth="1.5" opacity="0.6"/>
        <circle cx="40" cy="10" r="3.5" fill="#7DBFF5" opacity="0.9"/>
        <circle cx="70" cy="40" r="3.5" fill="#7DBFF5" opacity="0.9"/>
        <circle cx="40" cy="70" r="3.5" fill="#4A9EE8" opacity="0.8"/>
        <circle cx="10" cy="40" r="3.5" fill="#4A9EE8" opacity="0.8"/>
      </svg>
    ),
  };
  return icons[type] || icons['efficiency'];
};

export default function Values() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const values = [
    { iconType: 'efficiency', title: t('values.integrity'), desc: t('values.integrityDesc'), stat: '98–99.5%' },
    { iconType: 'lifecycle', title: t('values.longTerm'), desc: t('values.longTermDesc'), stat: '15K+ Cycles' },
    { iconType: 'reliability', title: t('values.excellence'), desc: t('values.excellenceDesc'), stat: '24/7' },
    { iconType: 'safety', title: t('values.innovation'), desc: t('values.innovationDesc'), stat: 'Multi-Layer' },
    { iconType: 'customization', title: t('values.collaboration'), desc: t('values.collaborationDesc'), stat: '300A+' },
  ];

  return (
    <section id="values" className="py-16 sm:py-32 relative overflow-hidden" style={{ backgroundColor: 'rgba(220,235,255,0.82)' }} dir={isRTL ? 'rtl' : 'ltr'}>

      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 relative">

        {/* Header */}
        <div className="text-center mb-10 sm:mb-20">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-px" style={{ backgroundColor: '#4A9EE8' }} />
            <span className="text-sm font-medium tracking-widest uppercase" style={{ color: '#4A9EE8' }}>{t('values.label')}</span>
            <div className="w-12 h-px" style={{ backgroundColor: '#4A9EE8' }} />
          </div>
          <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl leading-tight" style={{ color: '#0d2137' }}>
            {t('values.title1')} <span style={{ color: '#4A9EE8' }}>{t('values.title2')}</span>
          </h2>
          <p className="text-base sm:text-xl max-w-2xl mx-auto mt-4" style={{ color: '#4a5568' }}>{t('values.description')}</p>
        </div>

        {/* Cards - FIXED: stack vertically on mobile, proper padding */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
          {values.map((value, index) => (
            <div key={index} className={`group ${index === 4 ? 'lg:col-start-2' : ''}`}>
              <div
                className="relative rounded-2xl p-6 sm:p-10 h-full transition-all duration-500 overflow-hidden flex flex-col hover:shadow-xl"
                style={{
                  backgroundColor: '#ffffff',
                  boxShadow: '0 0 0 1.5px #185FA5, 4px 0 18px rgba(24,95,165,0.25), -4px 0 18px rgba(24,95,165,0.25), 0 4px 18px rgba(24,95,165,0.25), 0 -4px 18px rgba(24,95,165,0.25)'
                }}
              >
                <div className="absolute top-0 left-0 right-0 h-1 w-0 group-hover:w-full transition-all duration-700" style={{ backgroundColor: '#4A9EE8' }} />

                {/* Stat badge */}
                <div className="flex items-center justify-between mb-5 sm:mb-8">
                  <span
                    className="px-3 py-1.5 text-sm font-semibold rounded-full tracking-wider"
                    style={{ backgroundColor: '#e8f3fd', color: '#185FA5', border: '1px solid #b5d4f4' }}
                  >
                    {value.stat}
                  </span>
                </div>

                {/* Icon — smaller on mobile */}
                <div className="w-14 h-14 sm:w-24 sm:h-24 mb-5 sm:mb-8">
                  <ValueIcon type={value.iconType} />
                </div>

                {/* Title */}
                <h3 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 leading-tight" style={{ color: '#0d2137' }}>
                  {value.title}
                </h3>

                {/* Description — full width, normal wrapping */}
                <p className="leading-relaxed text-sm sm:text-base flex-1 w-full" style={{ color: '#374151' }}>
                  {value.desc}
                </p>

                <div className="mt-6 sm:mt-8 w-0 h-0.5 group-hover:w-full transition-all duration-700" style={{ backgroundColor: '#4A9EE8' }} />
              </div>
            </div>
          ))}
        </div>

        {/* Quote */}
        <div className="mt-12 sm:mt-20 rounded-2xl p-6 sm:p-12 text-center" style={{ backgroundColor: '#0d2137', border: '1px solid rgba(74,158,232,0.2)' }}>
          <i className={`ri-double-quotes-${isRTL ? 'r' : 'l'} text-4xl sm:text-5xl block mb-4 sm:mb-6`} style={{ color: 'rgba(74,158,232,0.4)' }} />
          <p className="text-lg sm:text-2xl lg:text-3xl font-serif leading-relaxed max-w-3xl mx-auto mb-6 sm:mb-8" style={{ color: 'rgba(255,255,255,0.85)' }}>
            {t('values.quote')}
          </p>
          <div className="flex items-center justify-center gap-4">
            <div className="w-12 h-px" style={{ backgroundColor: '#4A9EE8' }} />
            <span className="text-sm font-medium tracking-wider" style={{ color: '#4A9EE8' }}>ALEBEL ENERGY</span>
            <div className="w-12 h-px" style={{ backgroundColor: '#4A9EE8' }} />
          </div>
        </div>

      </div>
    </section>
  );
}
